import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { SelectVehicleMakePage } from './select-vehicle-make';

@NgModule({
  declarations: [SelectVehicleMakePage],
  imports: [IonicPageModule.forChild(SelectVehicleMakePage)],
})
export class SelectVehicleMakePageModule {}



// WEBPACK FOOTER //
// ./src/pages/select-vehicle-make/select-vehicle-make.module.ts